import React, { useState, useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { Modal, Typography, Tooltip, Button, Select, Tag } from "antd";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import useDeepCompareEffect from "use-deep-compare-effect";
import { useDispatch, useSelector } from "react-redux";
import {
  reload,
  loadPage,
  changePage,
  updateNewTask,
  setNonActive,
  setStatusFilter,
  setAssignedFilter,
  reset,
} from "./tasksSlice";
import ActionsTable from "../../components/templates/ActionsTable";
import FullName from "../../components/tables/FullName";
import Surface from "../../components/layouts/Surface";
import Date from "../../components/tables/Date";
import { EditOutlined } from "@ant-design/icons";
import { ReactComponent as ClientsImg } from "../../assets/no-clients.svg";
import AddNewTask from "./components/AddNewTask";
import Header from "./components/Header";
const { Text } = Typography;
const { Option } = Select;

const ClientsList = () => {
  const dispatch = useDispatch();
  const [visible, setVisible] = useState(false);
  const [mode, setMode] = useState("new");
  const [activeRecord, setActiveRecord] = useState(null);
  const [showMyTasks, setShowMyTasks] = useState(true);
  const {
    page: tasksPage,
    statusFilter,
    assignedFilter,
    showNonActive,
    blocked,
  } = useSelector((state) => state.tasks);
  const {
    current,
    pageSize,
    total,
    order,
    items,
    filter,
    finalfilters = { status: [] },
  } = tasksPage;

  const userId = useSelector((state) => state.user.profile.user);

  const loading = useSelector(
    (state) => state.pendingActions["tasks/loadPage"]
  );
  const intl = useIntl();
  let { branchId } = useParams();

  useDeepCompareEffect(() => {
    if (!blocked) {
      dispatch(loadPage());
    }
  }, [statusFilter, assignedFilter, current, filter, blocked, order]);

  useEffect(() => {
    dispatch(
      setAssignedFilter({
        filter: { assigned_to_id: userId },
      })
    );
    return () => {
      dispatch(reset());
    };
  }, [userId, dispatch]);

  const taskData = [
    {
      value: "opened",
      name: <FormattedMessage id="app.dataSelect.taskType.opened" />,
    },
    {
      value: "inprogress",
      name: <FormattedMessage id="app.dataSelect.taskType.inprogress" />,
    },
    {
      value: "cancelled",
      name: <FormattedMessage id="app.dataSelect.taskType.cancelled" />,
    },
    {
      value: "completed",
      name: <FormattedMessage id="app.dataSelect.taskType.completed" />,
    },
  ];

  const onInactiveChange = (e) => {
    dispatch(
      setNonActive({
        showNonActive: e.target.checked,
      })
    );
    let statusesFilters = [];
    const statuses = e.target.checked
      ? [
          { status: "opened" },
          { status: "inprogress" },
          { status: "cancelled" },
          { status: "completed" },
        ]
      : [{ status: "opened" }, { status: "inprogress" }];
    statuses.forEach((item, i) => {
      const found = finalfilters?.["status"]
        ? finalfilters["status"].find((t) => t === item.status)
        : null;

      if (found) {
        statusesFilters.push(item);
      }
    });
    dispatch(
      setStatusFilter({
        filter:
          statusesFilters.length > 0
            ? { $or: statusesFilters }
            : { $or: statuses },
      })
    );
  };

  const onMyTasksChange = (e) => {
    setShowMyTasks(e.target.checked);
    dispatch(
      setAssignedFilter({
        filter: e.target.checked ? { assigned_to_id: userId } : null,
      })
    );
  };

  const onAddClick = () => {
    setVisible(true);
    setMode("new");
  };

  const hide = () => {
    setVisible(false);
    dispatch(reload());
    setActiveRecord(null);
  };

  const onEdit = (record) => {
    setVisible(true);
    setMode("edit");
    setActiveRecord(record);
  };

  const onChange = async (record, val) => {
    const params = {
      branchId: record.branch_id,
      task: { status: val, id: record.id },
    };
    const action = await dispatch(updateNewTask(params));
    if (!action.error) {
      dispatch(reload());
    }
  };

  const filtersArr = showNonActive
    ? [
        {
          value: "opened",
          text: <FormattedMessage id="app.dataSelect.taskType.opened" />,
        },
        {
          value: "inprogress",
          text: <FormattedMessage id="app.dataSelect.taskType.inprogress" />,
        },
        {
          value: "cancelled",
          text: <FormattedMessage id="app.dataSelect.taskType.cancelled" />,
        },
        {
          value: "completed",
          text: <FormattedMessage id="app.dataSelect.taskType.completed" />,
        },
      ]
    : [
        {
          value: "opened",
          text: <FormattedMessage id="app.dataSelect.taskType.opened" />,
        },
        {
          value: "inprogress",
          text: <FormattedMessage id="app.dataSelect.taskType.inprogress" />,
        },
      ];
  return (
    <Surface>
      <Header
        onAddClick={onAddClick}
        onInactiveChange={onInactiveChange}
        showInactive={showNonActive}
        onMyTasksChange={onMyTasksChange}
        showMyTasks={showMyTasks}
      />
      <ActionsTable
        tableItems={[
          {
            title: "patient",
            width: "140px",
            render: ({ text }) => {
              return text ? (
                <FullName
                  record={text}
                  customLocation={`/branches/${branchId}/patients/${text.id}`}
                />
              ) : null;
            },
          },
          {
            title: "employee",
            width: "140px",
            render: ({ text }) => {
              return text ? (
                <FullName
                  record={text}
                  customLocation={`/branches/${branchId}/employees/${text.id}`}
                />
              ) : null;
            },
          },
          {
            title: "assigned_to",
            width: "140px",
            render: ({ text }) => {
              return <Text>{text ? text.name : ""}</Text>;
            },
          },

          {
            title: "created_at",
            width: "120px",
            render: Date,
            sortIndex: "created_at",
            sorter: true,
            columnProps: { format: "L" },
          },

          {
            title: "updated_at",
            width: "120px",
            render: Date,
            sortIndex: "updated_at",
            sorter: true,
            columnProps: { format: "L" },
          },
          {
            title: "type",
            width: "120px",
            ellipsis: true,
            render: ({ text }) => {
              return (
                text &&
                text.name && (
                  <Text ellipsis={{ tooltip: text.name }}>{text.name}</Text>
                )
              );
            },
          },
          { title: "description", ellipsis: true },
          { title: "comment", ellipsis: true },
          {
            title: "status",
            filteredValue: null,
            width: "130px",
            filters: filtersArr,
            render: ({ record, text }) => {
              const color =
                text === "opened"
                  ? "initial"
                  : text === "inprogress"
                  ? "#faad14"
                  : text === "cancelled"
                  ? "#FF4D51"
                  : "#52c41a";
              return (
                <Select
                  onChange={(val) => onChange(record, val)}
                  defaultValue={text}
                  style={{ color: color, width: "100px" }}
                >
                  {taskData.map((option) => (
                    <Option key={option.value} value={option.value}>
                      {option.name}
                    </Option>
                  ))}
                </Select>
              );
            },
          },
          {
            title: "actions",
            responsive: ["md"],
            width: "100px",
            render: ({ record }) => (
              <div style={{ display: "flex" }}>
                <Tooltip
                  title={intl.formatMessage({
                    id: "app.tasks.editTask",
                  })}
                >
                  <Button
                    type="text"
                    icon={<EditOutlined />}
                    onClick={() => onEdit(record)}
                  />
                </Tooltip>
              </div>
            ),
          },
        ]}
        ltrItems={[]}
        category={"tasks"}
        resource="tasks"
        deep={true}
        current={current}
        pageSize={pageSize}
        order={order}
        filters={finalfilters}
        total={total}
        loading={loading}
        textFilter={filter.freeText}
        reload={reload}
        loadPage={changePage}
        resetPage={reset}
        skipInitialLoad={true}
        items={items}
        filtersType={{ status: "string" }}
        showheader={false}
        emptyImage={<ClientsImg />}
        emptytext={<FormattedMessage id="app.tables.notasks" />}
      />
      <Modal
        closable={false}
        maskClosable={false}
        open={visible}
        footer={null}
        onCancel={hide}
        title={null}
        width={"fit-content"}
        styles={{
          body: {
            padding: 0,
          },
        }}
        destroyOnClose={true}
      >
        <AddNewTask
          hide={hide}
          mode={mode}
          record={activeRecord}
          addText={
            mode === "edit" ? (
              <FormattedMessage id="app.tasks.editTask" />
            ) : (
              <FormattedMessage id="app.tasks.addNewTask" />
            )
          }
        />
      </Modal>
    </Surface>
  );
};

export default ClientsList;
